var AssetDirectory = {
	"load": [
		"assets/.DS_Store",
		"assets/bgm/bgm.ogg",
		"assets/fonts/airbagfree-regular.woff",
		"assets/fonts/londonbetween.woff",
		"assets/htp/bugout_htp_1.png",
		"assets/htp/bugout_htp_2.png",
		"assets/htp/bugout_htp_3.png",
		"assets/htp/bugout_htp_4.png",
		"assets/ingame/bugout_arrow.png",
		"assets/ingame/bugout_bg.png",
		"assets/ingame/bugout_branch.png",
		"assets/ingame/bugout_bug_blue.png",
		"assets/ingame/bugout_bug_green.png",
		"assets/ingame/bugout_bug_pink.png",
		"assets/ingame/bugout_bug_purple.png",
		"assets/ingame/bugout_bug_red.png",
		"assets/ingame/bugout_bug_yellow.png",
		"assets/ingame/bugout_fx_sparkles_blue.png",
		"assets/ingame/bugout_gizmo1.png",
		"assets/ingame/bugout_gizmo2.png",
		"assets/ingame/bugout_gizmo3.png",
		"assets/ingame/bugout_gizmohand_hold.png",
		"assets/ingame/bugout_gizmohand_release.png",
		"assets/ingame/bugout_leaf1.png",
		"assets/ingame/bugout_leaf2.png",
		"assets/ingame/bugout_leaf3.png",
		"assets/ingame/bugout_wildbug.png",
		"assets/ingame/bugout_wildbug_con.png",
		"assets/ingame/bugout_wildbug_dew.png",
		"assets/ingame/bugout_wildbug_dew_set1.png",
		"assets/ingame/bugout_wildbug_dew_set2.png",
		"assets/ingame/bugs_ske.json",
		"assets/ingame/bugs_tex.json",
		"assets/ingame/bugs_tex.png",
		"assets/ingame/cm_ui_matchpopup.png",
		"assets/ingame/fx_cut_sparkle_ske.json",
		"assets/ingame/fx_cut_sparkle_tex.json",
		"assets/ingame/fx_cut_sparkle_tex.png",
		"assets/ingame/fx_sparkle.png",
		"assets/sfx/bonus.ogg",
		"assets/sfx/bugfly.ogg",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/correct.ogg",
		"assets/sfx/ding.ogg",
		"assets/sfx/nextbug.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/shoot.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/sfx/tic.ogg",
		"assets/sfx/toc.ogg",
		"assets/sfx/wild.ogg",
		"assets/titlescreen/bugout_title_bg.png",
		"assets/titlescreen/bugout_title_logo.png",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_close.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_loading_bar_con.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starbg.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preload/fonts/Exo-Bold.otf",
		"assets/preload/fonts/Exo-Medium.ttf",
		"assets/preload/fonts/proximanova-black.otf",
		"assets/preload/strings/gizmoloading_ske.json",
		"assets/preload/strings/gizmoloading_tex.json",
		"assets/preload/strings/strings.json",
		"assets/preload/ui/gfx_bg.png",
		"assets/preload/ui/gfx_loading.png",
		"assets/preload/ui/gizmoloading_tex.png"
	],
	"preloadstring": [
		"assets/strings/config.json"
	]
};